import { Component, OnInit, Input } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { CoreService, SecurityService, StorageService } from 'src/app/services';
import _ from 'lodash';
import { Helpers } from 'src/app/helpers';
import { UserAccount } from 'src/app/models';
declare var window: any;
@Component({
    selector: '[medpt-apps-menu]',
    templateUrl: './medpt-apps.component.html',
    styleUrls: ['./medpt-apps.component.scss'],
    standalone: false
})
export class MedptAppsMenuComponent implements OnInit {
  @Input() Sponsor: any;
  @Input() Portal: any;
  cdnEndPoint = environment.cdnEndPoint;
  envPath = environment.envPath;
  MedPointAppsEndPoint = environment.myAppUrl;
  IsExploreOtherAppsVisibled = false;
  IsAppsLoading: boolean = true;
  IsExploreAppsLoading: boolean = true;
  userInfo!: UserAccount;
  private appMenuImages: any = {
    'TriPort': { 'image': '/medpointapps/img/AppLogos/TriPort_color.svg', 'href': 'triport' },
    'CloudPort': { 'image': '/medpointapps/img/AppLogos/CloudPort_color.svg', 'href': 'cloudport' },
    'RegDoc': { 'image': '/medpointapps/img/AppLogos/RegDoc_color.svg', 'href': 'esafe' },
    'InSite': { 'image': '/medpointapps/img/AppLogos/InSite_color.svg', 'href': 'insite' },
    'FarSite': { 'image': '/medpointapps/img/AppLogos/FarSite_color.svg', 'href': 'farsite' },
    'EMS': { 'image': '/medpointapps/img/AppLogos/EMS_color.svg', 'href': 'ems' },
    'OpenSite': { 'image': '/medpointapps/img/AppLogos/OpenSite_color.svg', 'href': 'opensite' },
    'StudyStat': { 'image': '/medpointapps/img/app-logos/StudyStat_color.svg', 'href': 'studystat' },
    'RASPberryAI': { 'image': '/medpointapps/img/app-logos/RASPberryAI_color.svg', 'href': 'rai' },
  };
  cdnExploreAppsListUrl = environment.cdnEndPoint + '/triport/others/ExploreApps.js';

  myAccessibleApps: Array<any> = [];
  otherExploreApps: Array<any> = [];

  constructor(private coreService: CoreService, private storageService: StorageService, private securityService: SecurityService) {
    this.userInfo = this.securityService.currentUserValue;
  }

  ngOnInit(): void {
  }

  showExploreOtherApps() {
    this.IsExploreOtherAppsVisibled = true;
    this.IsAppsLoading = true;
    this.IsExploreAppsLoading = true;
    this.coreService.getUserPlatforms().then((appMenuList: Array<any>) => {
      
      this.IsAppsLoading = false;
      if (appMenuList?.length > 0) {
        appMenuList.forEach((item) => {
          Object.keys(this.appMenuImages).forEach((key, index, arr) => {
            
            if (key == item.MedPointPlatformName) {
              let sourceObject = this.appMenuImages[key];
              if (sourceObject)
                Object.assign(item, sourceObject);
              return;
            }
          });
        });

        this.myAccessibleApps = appMenuList;
        
      }

      this.coreService.getExploreAppsList().then((otherAppsList: any) => {
        this.IsExploreAppsLoading = false;
        let dataSource = otherAppsList[appMenuList[0].MedPointPlatformName];
        this.otherExploreApps = dataSource;
      }, (error) => { }).catch((error) => { }).finally(() => { this.IsExploreAppsLoading = false; });


    }, (error) => { }).catch((error) => { }).finally(() => { this.IsAppsLoading = false; });
  }

  hideExploreOtherApps() {
    this.IsExploreOtherAppsVisibled = false;
  }

  SendUserInterestedApp(app: any) {
    let activePlatforms = _.map(this.myAccessibleApps, (item) => { return item.MedPointPlatformId; });
    let postData = { "UserId": this.userInfo.UserGuid, "SelectedPlatform": app.ShortName, "ActivePlatformIds": activePlatforms, "SelectedActivity": "AvailableAppCard", "SourcePlatformId": <number>Helpers.getPlatformId() }
    this.storageService.UserInterestedApps(postData).then(() => { });
    window.open(app.LinkUrl, '_blank', 'noreferrer').focus();
  }
}
